import { Box, Card } from "@mui/material";
import { memo } from "react";
import { ActualOrderBookGrid } from "./actualOrderBookGrid";
import { useVisibleClusters } from "./useVisibleClusters";

const OrderBookGrid = memo(() => {
  // Every area streams at once now, so there is nothing left to switch between —
  // the old vertical area tabs are replaced by which column groups are shown.
  const { hideCluster, columnVisibilityModel } = useVisibleClusters();

  return (
    <Card
      elevation={5}
      sx={{
        height: "100%",
        width: "100%",
        // Only as wide as the columns it is showing, so the space beside it
        // belongs to whatever is docked there. Capped at the window for the
        // case where every cluster is shown on a narrow screen, where the grid
        // scrolls horizontally instead.
        // width: orderBookContentWidth(hiddenSet) + 10,
        maxWidth: "100%",
        flexShrink: 0,
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
      }}
    >
      <Box flexGrow={1} minHeight={0}>
        <ActualOrderBookGrid
          columnVisibilityModel={columnVisibilityModel}
          hideCluster={hideCluster}
        />
      </Box>
    </Card>
  );
});

OrderBookGrid.displayName = "OrderBookGrid";

export { OrderBookGrid };

export function uniqueBy<T>(arr: T[], prop: keyof T): T[] {
  return arr.reduce((a, d) => {
    if (!a.find((x) => x[prop] === d[prop])) {
      a.push(d);
    }
    return a;
  }, [] as T[]);
}
